export const APP_NAME = 'DCC Web Portal'
export const PERSIST_STORE_NAME = 'dcc_web_portal_admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
